import React, { useState } from 'react';
import { Table, Tag, Dropdown, Button } from 'antd';
import { MoreOutlined, EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Popconfirm, message } from 'antd';

const ShiftChangeRequestsView = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [data, setData] = useState([]); // داده‌های خالی برای شروع

  const handleDelete = (record) => {
    setData(data.filter(item => item.id !== record.id));
    message.success('درخواست با موفقیت حذف شد');
  };

  const getMenuItems = (record) => [
    {
      key: 'view',
      label: 'مشاهده',
      icon: <EyeOutlined />,
      onClick: () => console.log('مشاهده', record),
    },
    {
      key: 'edit',
      label: 'ویرایش',
      icon: <EditOutlined />,
      onClick: () => console.log('ویرایش', record),
    },
    {
      type: 'divider',
    },
    {
      key: 'delete',
      label: (
        <Popconfirm
          title="حذف درخواست"
          description="آیا از حذف این درخواست اطمینان دارید؟"
          onConfirm={() => handleDelete(record)}
          okText="بله"
          cancelText="خیر"
        >
          <span className="text-red-500">حذف</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined className="text-red-500" />,
      danger: true,
    },
  ];

  const columns = [
    {
      title: 'کارمند',
      dataIndex: 'employee',
      key: 'employee',
      width: 200,
      sorter: true,
      render: (text) => (
        <span style={{ fontFamily: 'CustomFont' }}>{text || '--'}</span>
      ),
    },
    {
      title: 'شیفت کاری کارمند',
      dataIndex: 'shift',
      key: 'shift',
      width: 200,
      sorter: true,
      render: (text) => (
        <span style={{ fontFamily: 'CustomFont' }}>{text || '--'}</span>
      ),
    },
    {
      title: 'تاریخ',
      dataIndex: 'date',
      key: 'date',
      width: 150,
      sorter: true,
      render: (text) => (
        <span style={{ fontFamily: 'CustomFont' }}>{text || '--'}</span>
      ),
    },
    {
      title: 'دلیل',
      dataIndex: 'reason',
      key: 'reason',
      width: 250,
      sorter: true,
      render: (text) => (
        <span style={{ fontFamily: 'CustomFont' }}>{text || '--'}</span>
      ),
    },
    {
      title: 'وضعیت',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      sorter: true,
      render: (status) => {
        const statusConfig = {
          pending: { color: 'orange', text: 'در انتظار' },
          approved: { color: 'green', text: 'تایید شده' },
          rejected: { color: 'red', text: 'رد شده' },
        };
        const config = statusConfig[status] || { color: 'default', text: status };
        return (
          <Tag color={config.color} style={{ fontFamily: 'CustomFont' }}>
            {config.text}
          </Tag>
        );
      },
    },
    {
      title: 'عملیات',
      key: 'actions',
      width: 80,
      fixed: 'left',
      render: (_, record) => (
        <Dropdown
          menu={{ items: getMenuItems(record) }}
          trigger={['click']}
          placement="bottomLeft"
        >
          <Button
            type="text"
            icon={<MoreOutlined />}
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm" style={{ fontFamily: 'CustomFont' }}>
      <Table
        columns={columns}
        dataSource={data}
        rowSelection={rowSelection}
        pagination={{
          total: data.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total, range) => (
            <span style={{ fontFamily: 'CustomFont' }}>
              نمایش {range[0]} تا {range[1]} از {total} ردیف
            </span>
          ),
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        locale={{
          emptyText: (
            <div style={{ fontFamily: 'CustomFont', padding: '40px 0' }}>
              هیچ داده‌ای در جدول وجود ندارد
            </div>
          ),
        }}
        scroll={{ x: 1000 }}
        className="custom-table"
      />
    </div>
  );
};

export default ShiftChangeRequestsView;



















